import axios from '@/plugins/axios';

const USAGE_DETAIL = '/usage-detail';
const USAGE_DETAIL_CSV = 'usage-detail-csv';
const USAGE_DETAIL_PDF = 'usage-detail-pdf';

export async function getUsageDetail(payload) {
  try {
    const { data } = await axios.get(`${USAGE_DETAIL}`, { params: payload });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function exportCSV(payload) {
  try {
    const data = await axios.post(`${USAGE_DETAIL_CSV}`, payload, {
      responseType: 'arraybuffer',
    });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function exportPDF(payload) {
  try {
    const data = await axios.post(`${USAGE_DETAIL_PDF}`, payload, {
      responseType: 'arraybuffer',
    });

    return data;
  } catch (error) {
    return { error };
  }
}
